import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { AssetUnderManagementModel } from "../../../../../Wrap/Models/Models/Business/AssetUnderManagement/AssetUnderManagementModel";
import { BusinessManagementDispatcher } from "./Variable";

export interface BusinessManagementStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: AssetUnderManagementModel;
}

export class BusinessManagementStatic extends BaseStore<BusinessManagementStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(BusinessManagementDispatcher, (actionData) =>
            this.onBusinessManagementStoreResponse(actionData)
        );
    }

    public getLastResult(): BusinessManagementStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return JSON.parse(JSON.stringify(this.getState().data));
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): BusinessManagementStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onBusinessManagementStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
